// ==== action types ====

export const CALCULATE_RPP_TOTAL_FUND_ALLOCATION = 'INVESTMENT/CALCULATE_RPP_TOTAL_FUND_ALLOCATION'
export const calculateTotalFundAllocation = (code, fundAllocation) => {
  return {
    type: CALCULATE_RPP_TOTAL_FUND_ALLOCATION,
    payload: {
      code,
      fundAllocation,
    },
  }
}
export const UPDATE_RPP_FUND_ALLOCATIONS = 'INVESTMENT/UPDATE_RPP_FUND_ALLOCATIONS'
export const updateRppFundAllocation = (allocations) => {
  return {
    type: UPDATE_RPP_FUND_ALLOCATIONS,
    payload: allocations,
  }
}
export const UPDATE_RPP_TOTAL_FUND_ALLOCATION = 'INVESTMENT/UPDATE_RPP_TOTAL_FUND_ALLOCATION'
export const updateRppTotalFundAllocation = (totalFundAllocation) => {
  return {
    type: UPDATE_RPP_TOTAL_FUND_ALLOCATION,
    payload: totalFundAllocation,
  }
}
export const TOGGLE_RPP_FUND_ALLOCATION = 'INVESTMENT/TOGGLE_RPP_FUND_ALLOCATION'

export const toggleFundAllocation = (fund) => {
  return {
    type: TOGGLE_RPP_FUND_ALLOCATION,
    payload: fund,
  }
}

export const RESET_RPP_FUND_ALLOCATION = 'INVESTMENT/RESET_RPP_FUND_ALLOCATION'
export const resetFundAllocations = () => {
  return {
    type: RESET_RPP_FUND_ALLOCATION,
  }
}

export const UPDATE_RPP_ACCEPT_FUND_ALLOCATION = 'INVESTMENT/UPDATE_RPP_ACCEPT_FUND_ALLOCATION'

export const updateRppAcceptFundAllocation = (acceptFundAllocation) => {
  return {
    type: UPDATE_RPP_ACCEPT_FUND_ALLOCATION,
    payload: acceptFundAllocation,
  }
}

export const RESET_RPP_ACCEPT_FUND_ALLOCATION = 'INVESTMENT/RESET_RPP_ACCEPT_FUND_ALLOCATION'

export const resetRppAcceptFundAllocation = () => {
  return {
    type: RESET_RPP_ACCEPT_FUND_ALLOCATION,
  }
}

export const RPP_ACCEPT_HIGHER_RISK_INVESTMENT = 'RPP_ACCEPT_HIGHER_RISK_INVESTMENT'

export const rppAcceptHigherRiskInvestment = () => ({
  type: RPP_ACCEPT_HIGHER_RISK_INVESTMENT,
})

export const RPP_ACCEPT_FOREIGN_INVESTMENT = 'RPP_ACCEPT_FOREIGN_INVESTMENT'

export const ANSWER_QUESTION_TO_ACCEPT_RPP_FOREIGN_INVESTMENT = 'ANSWER_QUESTION_TO_ACCEPT_RPP_FOREIGN_INVESTMENT'

export const rppAcceptForeignInvestment = () => ({
  type: RPP_ACCEPT_FOREIGN_INVESTMENT,
})

export const answerQuestionToAcceptRppForeignInvestment = (isAccept) => ({
  type: ANSWER_QUESTION_TO_ACCEPT_RPP_FOREIGN_INVESTMENT,
  payload: isAccept,
})
